// Widget CSS
import '@/css/_elementor/widgets/video_widget.css';

// ....................................................................

import Player from '@vimeo/player';

// ....................................................................
// Helper: Update URL param
// ....................................................................

function updateUrlParam(url, param, value) {
	const urlObj = new URL(url, window.location.origin);
	urlObj.searchParams.set(param, value);
	return urlObj.toString();
}

// ....................................................................
// Global pause logic
// ....................................................................

let allVideoWrappers = [];

function pauseAllExcept(currentWrapper) {
	allVideoWrappers.forEach((wrapper) => {
		if (wrapper === currentWrapper) return;

		const video = wrapper.querySelector('video');
		const iframe = wrapper.querySelector('iframe');

		if (video && !video.paused) video.pause();

		if (iframe?.classList.contains('youtube')) {
			const origin = new URL(iframe.src).origin;
			iframe.contentWindow.postMessage(JSON.stringify({ event: 'command', func: 'pauseVideo', args: [] }), origin);
		}

		iframe?._vimeoPlayer?.pause();

		wrapper.classList.remove('is-playing', 'is-clicked');
	});
}

// ....................................................................
// Hide-on-play helper
// ....................................................................

function toggleHideOnPlay(wrapper) {
	const outerContainer = wrapper.closest('.e-con-inner');
	if (!outerContainer) return;

	const hideEl = outerContainer.querySelector('.hide-on-play');
	if (!hideEl) return;

	const isHidden = hideEl.style.opacity === '0';
	hideEl.style.opacity = isHidden ? '1' : '0';
	hideEl.style.visibility = isHidden ? 'visible' : 'hidden';
}

// ....................................................................
// Initialize video widgets
// ....................................................................

function initVideoWidgets(container = document) {
	const wrappers = Array.from(container.querySelectorAll('.video-wrapper'));
	allVideoWrappers.push(...wrappers);

	wrappers.forEach((wrapper) => {
		const video = wrapper.querySelector('video');
		const iframe = wrapper.querySelector('iframe');

		// --------------------------------------------------
		// HTML5 VIDEO
		// --------------------------------------------------
		if (video) {
			video.addEventListener('click', (e) => e.stopPropagation());

			wrapper.addEventListener('click', () => {
				pauseAllExcept(wrapper);
				wrapper.classList.add('is-clicked');

				if (video.paused) video.play();
				else video.pause();

				toggleHideOnPlay(wrapper);
			});

			video.addEventListener('play', () => wrapper.classList.add('is-playing'));
			video.addEventListener('pause', () => wrapper.classList.remove('is-playing'));
			video.addEventListener('ended', () => wrapper.classList.remove('is-clicked'));

			return;
		}

		if (!iframe) return;

		const src = iframe.getAttribute('src') || '';

		// --------------------------------------------------
		// YOUTUBE
		// --------------------------------------------------
		if (src.includes('youtube.com') || src.includes('youtu.be')) {
			iframe.classList.add('youtube');

			wrapper.addEventListener(
				'mouseenter',
				() => {
					let updated = src;
					if (!src.includes('enablejsapi=1')) updated = updateUrlParam(updated, 'enablejsapi', '1');
					if (!src.includes('rel=0')) updated = updateUrlParam(updated, 'rel', '0');
					updated = updateUrlParam(updated, 'modestbranding', '1');
					iframe.setAttribute('src', updated);
				},
				{ once: true },
			);

			wrapper.addEventListener('click', () => {
				pauseAllExcept(wrapper);
				const origin = new URL(iframe.src).origin;

				const isPlaying = wrapper.classList.toggle('is-playing');
				iframe.contentWindow.postMessage(JSON.stringify({ event: 'command', func: isPlaying ? 'playVideo' : 'pauseVideo', args: [] }), origin);

				toggleHideOnPlay(wrapper);
			});

			return;
		}

		// --------------------------------------------------
		// VIMEO
		// --------------------------------------------------
		if (src.includes('vimeo.com')) {
			iframe.classList.add('vimeo');
			const player = new Player(iframe);
			iframe._vimeoPlayer = player;

			const playerID = wrapper.dataset.playerid;

			wrapper.addEventListener(
				'mouseenter',
				() => {
					const url = new URL(iframe.src, window.location.href);
					url.searchParams.set('api', '1');
					url.searchParams.set('player_id', playerID);
					url.searchParams.set('byline', '0');
					url.searchParams.set('title', '0');
					url.searchParams.set('dnt', '1');
					iframe.setAttribute('src', url.toString());
				},
				{ once: true },
			);

			player.on('pause', () => wrapper.classList.remove('is-playing'));
			player.on('ended', () => wrapper.classList.remove('is-playing'));

			wrapper.addEventListener('click', async () => {
				pauseAllExcept(wrapper);
				const paused = await player.getPaused();

				if (paused) {
					wrapper.classList.add('is-playing');
					await player.play();
				} else {
					wrapper.classList.remove('is-playing');
					await player.pause();
				}

				toggleHideOnPlay(wrapper);
			});
		}
	});
}

// ....................................................................
// Elementor init
// ....................................................................

window.addEventListener('elementor/frontend/init', () => {
	elementorFrontend.hooks.addAction('frontend/element_ready/video_widget.default', (scope) => {
		const scopeEl = scope[0];
		if (!scopeEl) return;

		// ...

		// if not in elementor editor
		if (!window.elementor) {
			initVideoWidgets(scopeEl);
		} // if (!window.elementor)
	});
});
